// tslint:disable:trailing-comma
import { getApp } from '@mx/util/get-app';
import { getSystem } from '@mx/util/get-system';
import { getAllQueryString } from '@mx/util/get-all-query-string';
import { getProp } from '@mx/util/get-prop';
import { Container } from '../common-enum';
import {
  setSessionStorage,
  hasSessionStorage,
  getSessionStorage,
} from '../util/storage';

export interface EnvProperties {
  readonly neoUniqueId: string;
  readonly system: string;
  readonly isIOS: boolean;
  readonly isAndroid: boolean;
  readonly isTitans: boolean;
  readonly container: Container;
  readonly appName: string;
  readonly network: string;
  readonly isOffline: boolean;
  readonly webCoreVersion: string;
  readonly isPageReload: boolean;
}

class Env {
  // 页面加载标识 sessionStorage 键名
  private static pageLoadedSessionKey = 'page_loaded';

  private neoUniqueId: string = '';

  private system: string;

  private isIOS: boolean;

  private isAndroid: boolean;

  private isTitans: boolean;

  private container: Container;

  private appName: string;

  private network: string = getProp(navigator, ['connection', 'effectiveType']);

  private isOffline: boolean = !!window.__ot__;

  // WebView 内核版本
  private webCoreVersion: string;

  // 页面是否重新加载
  private isPageReload: boolean = false;

  constructor() {
    const urlParams = getAllQueryString();
    const userAgent = window?.navigator?.userAgent || '';
    const neoUA = /\sneo\/\w{16}/.exec(userAgent);

    // 读取 sessionStorage，设置页面是否重新加载
    if (hasSessionStorage(Env.pageLoadedSessionKey, '1')) {
      this.isPageReload = true;
    }
    // 页面加载标识写入 sessionStorage
    setSessionStorage(Env.pageLoadedSessionKey, '1');
    // 从 UA 中解析 neo/xxxxxx ,作为全局唯一标识用于埋点跟监控
    const neoId = /\sneo\/\w{16}/.exec(window.navigator.userAgent);
    if (
      Array.isArray(neoId) &&
      typeof neoId[0] === 'string' &&
      neoId[0].indexOf('/') !== -1
    ) {
      this.neoUniqueId = neoId[0].split('/')[1];
    } else {
      const neoIdKey = 'pay_deduction_part_neo_unique_id';
      const id = getSessionStorage(neoIdKey) || '';
      if (/^\w{18}$/.test(id)) {
        this.neoUniqueId = id;
      } else {
        this.neoUniqueId =
          'js' +
          Math.random().toString(16).slice(-8) +
          new Date().getTime().toString(16).slice(-8);
        setSessionStorage(neoIdKey, this.neoUniqueId);
      }
    }
    this.system = getSystem();
    this.isIOS = this.system === 'ios';
    this.isAndroid = this.system === 'android';
    this.isTitans = (KNB && KNB.env && KNB.env.isTitans) || false;

    if (neoUA && neoUA.length && neoUA[0] && neoUA[0].indexOf('/') !== -1) {
      this.container = Container.Neo;
    } else if (this.isTitans) {
      this.container = Container.Titans;
    } else {
      this.container = Container.Others;
    }

    this.appName = getApp(urlParams.utm_campaign);

    this.webCoreVersion = '';
    if (this.isIOS) {
      const appleWebKitUA = /\sAppleWebKit\/\S*\s/.exec(userAgent);
      if (
        appleWebKitUA &&
        appleWebKitUA.length &&
        appleWebKitUA[0] &&
        appleWebKitUA[0].indexOf('/') !== -1
      ) {
        this.webCoreVersion = appleWebKitUA[0].trim().split('/')[1];
      }
    } else if (this.isAndroid) {
      const appleWebKitUA = /\sAppleWebKit\/\S*\s/.exec(userAgent);
      if (
        appleWebKitUA &&
        appleWebKitUA.length &&
        appleWebKitUA[0] &&
        appleWebKitUA[0].indexOf('/') !== -1
      ) {
        this.webCoreVersion = appleWebKitUA[0].trim().split('/')[1];
      }
    }
  }

  getEnv(): EnvProperties {
    return {
      neoUniqueId: this.neoUniqueId,
      system: this.system,
      isIOS: this.isIOS,
      isAndroid: this.isAndroid,
      isTitans: this.isTitans,
      container: this.container,
      appName: this.appName,
      network: this.network,
      isOffline: this.isOffline,
      webCoreVersion: this.webCoreVersion,
      isPageReload: this.isPageReload,
    };
  }
}

const env = new Env();

export { env };
export default env;
